import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  root: {
    marginLeft: 0
  }
})
